import { styled, createTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Chip from "@mui/material/Chip";
import Tab from "@mui/material/Tab";
import Select from "@mui/material/Select";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

export const CssTextField = styled(TextField)({
  width: "400px",
  height: "40px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 8,
  padding: "0px 8px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  backgroundColor: "#303234",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#BBBCBC",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
});

export const CssTextFieldSignIn = styled(TextField)({
  width: "400px",
  height: "40px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 8,
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  padding: "0px 8px",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#BBBCBC",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
});

export const CssTextFieldPhone = styled(TextField)({
  width: "280px",
  height: "40px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 8,
  padding: "0px 0px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#BBBCBC",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
});

export const CssTextFieldPhoneCode = styled(Select)({
  width: "100%",
  height: "40px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 8,
  padding: "0px 16px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#BBBCBC",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
});

export const CssButton = styled(Button)({
  width: "130px",
  height: "40px",
  fontWeight: "300",
  backgroundColor: "#43B02A",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssDataJacketHomePageButton = styled(Button)({
  width: "300px",
  height: "80px",
  backgroundColor: "#26890D",
  fontWeight: "bold",
  fontSize: "16px",
  color: "white",
  borderRadius: "15px",
  border: "solid 2px white",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&:hover": {
    backgroundColor: "#97999B",
    cursor: "pointer",
  },
});

export const CssDataJacketButton = styled(Button)({
  width: "350px",
  height: "40px",
  backgroundColor: "#26890D",
  fontWeight: "bold",
  fontSize: "16px",
  color: "white",
  border: "solid 2px white",
  borderRadius: "5px 5px 5px 5px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&:hover": {
    backgroundColor: "#97999B",
    cursor: "pointer",
  },
});

export const CssDataJacketMiniButton = styled(Button)({
  width: "20px",
  height: "30px",
  backgroundColor: "#26890D",
  fontWeight: "bold",
  fontSize: "16px",
  color: "white",
  border: "solid 2px white",
  borderRadius: "5px 5px 5px 5px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&:hover": {
    backgroundColor: "#97999B",
    cursor: "pointer",
  },
});

export const CssButtonSignIn = styled(Button)({
  width: "130px",
  height: "40px",
  fontWeight: "300",
  marginTop: "16px",
  marginRight: "40px",
  marginLeft: "auto",
  backgroundColor: "#26890D",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssButtonDisplay = styled(Button)({
  display: "inherit",
  width: "130px",
  height: "40px",
  fontWeight: "300",
  marginTop: "16px",
  marginRight: "16px",
  marginLeft: "auto",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  backgroundColor: "#26890D",
  "&:hover": {
    backgroundColor: "#97999B",
    cursor: "pointer",
  },
});

export const CssLink = styled(Link)({
  fontSize: "16px",
  fontWeight: "600",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBtnTypography = styled(Typography)({
  color: "white",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssMessageTypography = styled(Typography)({
  color: "white",
  paddingTop: "36px",
  fontSize: "16px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssDataJacketTitleTypography = styled(Typography)({
  color: "white",
  marginLeft: "16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  fontSize: "20px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssDataJacketSubTitleTypography = styled(Typography)({
  color: "white",
  marginLeft: "4px",
  paddingTop: "8px",
  paddingBottom: "8px",
  fontSize: "18px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssContentRow = styled(Typography)({
  color: "#525252",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  fontWeight: "bold",
  fontSize: "14px",
});

export const CssDataJacketBodyTypography = styled(Typography)({
  color: "#E6E6E6",
  marginLeft: "16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  marginRight: "16px",
  fontSize: "14px",
  whiteSpace: "pre-line",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBoldDataJacketBodyTypography = styled(Typography)({
  color: "#E6E6E6",
  marginLeft: "16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  marginRight: "16px",
  fontSize: "14px",
  fontWeight: "bold",
  whiteSpace: "pre-line",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBoldDataJacketLogoTypography = styled(Typography)({
  color: "#E6E6E6",
  marginLeft: "15px",
  fontSize: "18px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBoldDataJacketFooterTypography = styled(Typography)({
  color: "#FFFFFF",
  fontSize: "18px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBoldDataJacketHomeTypography = styled(Typography)({
  color: "#E6E6E6",
  paddingTop: "0px",
  paddingBottom: "4px",
  marginRight: "16px",
  fontSize: "55px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssBoldDataJacketHomeBodyTypography = styled(Typography)({
  color: "#E6E6E6",
  marginLeft: "16px",
  paddingTop: "0px",
  paddingBottom: "4px",
  marginRight: "16px",
  fontSize: "20px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssLoginTitleTypography = styled(Typography)({
  color: "white",
  marginLeft: "40px",
  marginTop: "8px",
  paddingBottom: "8px",
  marginRight: "16px",
  fontSize: "16px",
  fontWeight: "bold",
  whiteSpace: "pre-line",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssDataSetBodyTypography = styled(Typography)({
  color: "#E6E6E6",
  marginLeft: "16px",
  paddingTop: "8px",
  paddingBottom: "8px",
  marginRight: "16px",
  fontSize: "14px",
  fontWeight: "bold",
  whiteSpace: "pre-line",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&:hover": {
    backgroundColor: "#424242",
    cursor: "pointer",
    paddingLeft: "8px",
  },
});

export const CssDataJacketBodyChip = styled(Chip)({
  color: "white",
  marginLeft: "8px",
  marginTop: "8px",
  marginRight: "16px",
  fontSize: "14px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssItem = styled(Item)({
  backgroundColor: "black",
  textAlign: "left",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const ValidationTextField = styled(TextField)({
  width: "400px",
  height: "40px",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: 8,
  padding: "0px 8px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "& label.Mui-focused": {
    color: "green",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#BBBCBC",
    },
    "&:hover fieldset": {
      borderColor: "black",
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
  },
});

export const CssPasswordBox = styled(Box)({
  position: "absolute",
  top: "30%",
  bottom: "50%",
  left: "calc(50% - 210px)",
  right: 0,
  margin: "auto",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssPasswordStack = styled(Stack)({
  marginLeft: "32px",
  paddingTop: "32px",
  alignItems: "start",
  justifyItems: "left",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssTabButton = styled(Button)({
  width: "30%",
  height: 0,
  color: "#1D1D1D",
  marginLeft: "32px",
  borderTopWidth: 100,
  borderLeftWidth: 80,
  borderLeftColor: "transparent",
  borderRightWidth: 80,
  borderRightColor: "transparent",
  borderStyle: "solid",
  position: "relative",
  textAlign: "center",
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  letterSpacing: "1.6px",
  lineHeight: "100px" /* Just for demo */,
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssTabLink = styled(Tab)({
  minWidth: "300px",
  height: 0,
  marginTop: "20px",
  marginBottom: "20px",
  position: "relative",
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  letterSpacing: "1.6px",
  lineHeight: "100px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  "&.Mui-selected": {
    color: "white",
    fontWeight: "bold",
    backgroundColor: "#75787B",
  },
  "&:hover": {
    color: "white",
    backgroundColor: "#75787B",
  },
});

export const MainPageBox = styled(Box)({
  position: "relative",
  display: "block",
  backgroundColor: "#303234",
  flexGrow: 1,
  minHeight: "100vh",
  height: "100hv",
  alignItems: "center",
  justifyContent: "center",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const customGeneralTheme = createTheme({
  palette: {
    primary: {
      main: "#303234",
    },
    secondary: {
      main: "#97999B",
    },
  },
});

export const SearchGrid = styled(Grid)`
  ${({ theme }) => `
  border-radius: '10px';
  background-color: "#505458";
  transition: ${theme.transitions.create(["background-color", "transform"], {
    duration: theme.transitions.duration.standard,
  })};
  `}
`;

export const CssTableCell = styled(TableCell)({
  color: "white",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  verticalAlign: "top",
  borderColor: "transparent",
  borderLeft: "1px solid white",
  borderBottom: "1px solid white",
  fontSize: "16px",
});

export const CssTableCellHead = styled(TableCell)({
  color: "white",
  fontSize: "16px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  backgroundColor: "#303234",
  borderTop: "1px solid white",
  borderLeft: "1px solid white",
});

export const CssTableRow = styled(TableRow)({
  backgroundColor: "#303234",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssStickyTableCell = styled(TableCell)({
  color: "white",
  backgroundColor: "#303234",
  verticalAlign: "top",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  borderColor: "transparent",
  left: 0,
  borderBottom: "1px solid white",
  borderLeft: "1px solid white",
  position: "sticky",
});

export const CssStickyTableCellHead = styled(TableCell)({
  color: "white",
  fontSize: "16px",
  fontWeight: "bold",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
  borderTop: "1px solid white",
  borderLeft: "1px solid white",
  backgroundColor: "#303234",
  left: 0,
  position: "sticky",
});

export const CssTableCellUserSupport = styled(TableCell)({
  color: "white",
  fontSize: "16px",
  padding: "5px",
  backgroundColor: "#303234",
  borderTop: "1px solid white",
  borderLeft: "1px solid white",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssTypographyUserSupport = styled(Typography)({
  color: "#BDD7EE",
  fontSize: "28px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});

export const CssTypographyConnectDjSupplement = styled(Typography)({
  color: "white",
  fontWeight: "bold",
  fontSize: "18px",
  paddingTop: "8px",
  paddingBottom: "8px",
  fontFamily: "Noto Sans JP, Meiryo, -apple-system",
});
